<template>
  <div>
    <div class="head-cont">
      <span class="title">Circles {{ name }} is part of </span>
      <div v-if="selectedFilter === 'All' && otherMembers.length === 0 ? false : true" class="sort-dropdown">
        <a-dropdown :trigger="['click']" :getPopupContainer="trigger => trigger.parentNode">
          <a class="show" @click="e => e.preventDefault()">
            Show <span class="all">{{ selectedFilterName() }}</span> <a-icon type="down" />
          </a>
          <a-menu class="drop-ele" slot="overlay">
            <a-menu-item class="">
              <a @click="() => handleSelectCircle('')">All </a>
            </a-menu-item>
            <a-menu-item>
              <a @click="() => handleSelectCircle('people')">People ({{ peopleCount }})</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="() => handleSelectCircle('hospital_administrator')">Hospitals ({{ hospitalCount }}) </a>
            </a-menu-item>
            <a-menu-item>
              <a @click="() => handleSelectCircle('clinic_administrator')">Clinics ({{ clinicCount }}) </a>
            </a-menu-item>
            <a-menu-item>
              <a @click="() => handleSelectCircle('nfp_administrator')">Non for profits ({{ nfpCount }}) </a>
            </a-menu-item>
            <a-menu-item>
              <a @click="() => handleSelectCircle('hcp')">Advanced medical professionals ({{ hcpCount }}) </a>
            </a-menu-item>
            <a-menu-item>
              <a @click="() => handleSelectCircle('doctor')">Physician ({{ physicianCount }})</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border position-absolute spinner-class"></div>
    </div>
    <div v-if="!loading">
      <div v-if="otherMembers.length">
        <div v-for="members in otherMembers" :key="members">
          <div v-if="members.role === 'patient' || members.role === 'advocate' || members.role === 'caregiver'" class="claim-card">
            <div class="user-name d-flex p-3">
              <a @click="viewProfile(members)" class="bg-img d-block background-image">
                <a-avatar :style="{ color: ' #ffffff !important', 'background-color': (members.url ? members.url : '') ? '' : '#C997C5' }" :size="70" :src="members.url" class="text-capitalize">
                  {{ members.display_name[0] }}
                </a-avatar>
              </a>
              <div class="divider" />
              <div class="right-items profile-btn">
                <div class="d-inline-block text-left align-self-center overflow-hidden weedth">
                  <p
                    class="bold-text text-truncate cp text-capitalize fw700 font20"
                    :style="{ color: '#0F1734', 'line-height': '30px', 'margin-bottom': '8px !important' }"
                    @click="viewProfile(members)"
                  >
                    {{ members.display_name }}
                  </p>
                  <p
                    :style="{ color: '#94A3B8', 'font-weight': '700', 'font-size': '14px', 'line-height': '21px', 'margin-bottom': '8px !important' }"
                    v-if="members.location && members.location[0].city && members.location[0].state"
                    class="m-0 doc-loc text-truncate"
                  >
                    <img src="../../../../assets/images/addphy-location.png" />
                    {{ members.location[0].city }},
                    {{ members.location[0].state }}
                  </p>
                  <p :style="{ color: '#0F1734', 'font-size': '14px', 'line-height': '21px', 'font-weight': 'bold', 'margin-bottom': '8px !important' }">{{ members.no_of_members }} circle members</p>
                </div>
                <div class="meet-others">
                  <a-button
                    :style="{ background: getPrimaryColor(), 'pointer-events': 'all', 'font-size': '14px', 'border-radius': '6px', padding: '12px 24px' }"
                    class="font-white primary-button profile-btn"
                    @click="viewProfile(members)"
                    :loading="activeUser === members.id ? isPageRouting : false"
                  >
                    View Profile
                  </a-button>
                </div>
              </div>
            </div>
          </div>
          <SelfProviderCard
            v-else
            :info="members"
            :type="
              members.role === 'hospital_administrator'
                ? 'hospital'
                : members.role === 'clinic_administrator'
                ? 'clinic'
                : members.role === 'nfp_administrator'
                ? 'nfp'
                : members.role === 'ahp'
                ? 'hcps'
                : members.role
            "
            :isSelf="true"
          />
        </div>
        <span
          v-if="otherMembers.length != this.pagination.total_count"
          class="viewmore"
          :style="{ color: getPrimaryColor(), textAlign: 'center', display: 'block', cursor: 'pointer' }"
          @click="fetchOtherCircleMembers(true)"
        >
          View More
        </span>
      </div>
      <div v-if="otherMembers.length === 0" class="text-center">
        <div class="dailogbox">
          <div class="dailog-wrapper">
            <span class="dailog">No circles joined yet</span>
            <span class="sub-dailog">Your not part of any circles yet.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "../../../../main"
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"
import SelfProviderCard from "../../../home/provider/selfProfiderCard.vue"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "OtherCircleMembers",
  components: {
    SelfProviderCard,
  },
  data() {
    return {
      loading: true,
      otherMembers: [],
      currentPage: 1,
      limit: 6,
      showNo: true,
      filterRole: "",
      circleMembers: [],
      normalRole: [],
      doctorRole: [],
      activeUser: 0,
      isPageRouting: false,
      physicianCount: 0,
      hospitalCount: 0,
      nfpCount: 0,
      clinicCount: 0,
      hcpCount: 0,
      peopleCount: 0,
      set: ["hospital_administrator", "clinic_administrator", "nfp_administrator", "hcp", "doctor"],
      selectedFilter: "All",
    }
  },

  props: {
    name: String,
  },

  created() {
    console.warn("OtherCircleMembers.vue is created")
    this.fetchOtherCircleMembers()
  },

  methods: {
    viewProfile(user) {
      this.activeUser = user.id
      this.isPageRouting = true
      if (user.id === this.authUser.user.id) {
        this.routeToAuthProfile(this.authUser.user.role)
      } else {
        UserRepository.getOtherUserProfile(user, this.currentCircle.id)
          .then(res => {
            const data = { ...res.data.data.user_info, on_circle: res.data.data.on_circle, request_to_add: res.data.data.request_to_add }
            this.$store.commit("User/setViewUser", { data })
            switch (user.role) {
              case "doctor":
                this.$router.push({ name: "ViewDoctorUpdates", params: { id: user.id } })
                break
              case "patient":
                this.$router.push({ name: "ViewPatientUpdates", params: { id: user.id } })
                break
              case "caregiver":
                this.$router.push({ name: "ViewPatientUpdates", params: { id: user.id, role: 'caregiver' } })
                break
              case "advocate":
                this.$router.push({ name: "ViewAdvocateUpdates", params: { id: user.id } })
                break
              default:
                break
            }
          })
          .catch(err => {})
      }
    },

    handleSelectCircle(role) {
      if (role === "") {
        this.selectedFilter = "All"
      } else {
        this.selectedFilter = role
      }
      this.filterRole = role
      this.currentPage = 1
      this.fetchOtherCircleMembers()
    },

    selectedFilterName() {
      switch (this.selectedFilter) {
        case "":
          return "All"
        case "doctor":
          return "Physicians"
        case "people":
          return "People"
        case "hospital_administrator":
          return "Hospitals"
        case "clinic_administrator":
          return "Clinics"
        case "nfp_administrator":
          return "Non for profits"
        case "hcp":
          return "Advanced medical professionals"
        default:
          return "All"
      }
    },

    /**
     * Fetch self circle members
     */
    fetchOtherCircleMembers(append = false) {
      this.loading = true
      UserRepository.getOtherCircleMembers(this.authUser.user, this.currentCircle.id, this.currentPage, this.limit, this.filterRole)
        .then(res => {
          if (append) {
            this.otherMembers = this.otherMembers.concat(res.data.data.data ? res.data.data.data : [])
            this.loading = false
          } else {
            this.otherMembers = res.data.data.data ? res.data.data.data : []
            this.pagination = res.data.data.paginator
            this.loading = false
          }
          console.log("otherMembers:", this.otherMembers)
          this.currentPage = this.currentPage + 1
        })
        .catch(err => {})
      UserRepository.getOtherCircleMembersCount(this.authUser.user, this.currentCircle.id, this.currentPage, this.limit, this.filterRole).then(res => {
        this.peopleCount = res.data.data.people_count
        this.physicianCount = res.data.data.doctor_count
        this.hospitalCount = res.data.data.hospital_count
        this.clinicCount = res.data.data.clinic_count
        this.hcpCount = res.data.data.hcp_count
        this.nfpCount = res.data.data.nfp_count
      })
    },

    /**
     * Add Member to Circle
     */
    addMemberToCircle(user) {
      UserRepository.addToCircle(user, this.currentCircle.id)
        .then(res => {
          // this.fetchOtherCircleMembers()
          eventBus.$emit("refresh-circle-members")
        })
        .catch(err => {})
    },
    sayHiToMember() {},
  },
}
</script>

<style lang="scss" scoped>
.head-cont {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  @media screen and (max-width: 700px) {
    flex-wrap: wrap;
    gap: 10px;
  }
}

.title {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}

.sub-dailog {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #33415f;
}

.dailog {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #0f1734;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
}

.weedth {
  width: 451px;

  @media screen and (max-width: 900px) {
    width: 100%;
  }
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  // height: 163px;
  background: #f1f5f9;
  border-radius: 8px;
}

.show {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734 !important;
  white-space: nowrap;
}

.all {
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #0f1734 !important;
}

.divider {
  margin-top: -16px;
  border: 1px solid #cbd5e1;
  height: 159px;
  background-color: #cbd5e1;
  margin-left: 26.5px;

  @media screen and (max-width: 900px) {
    margin-left: 15px;
    margin-top: -16px;
    height: inherit;
  }
}

.right-items {
  display: flex;
  width: 100%;
  justify-content: space-between;
  overflow: none !important;
  margin-left: 24px;

  @media screen and (max-width: 900px) {
    display: block;
    margin-left: 15.5px;
  }

  @media screen and (max-width: 600px) {
    display: block;
    margin-left: 15.5px;
  }
}

.meet-others {
  display: flex;
  align-items: center;

  @media screen and (max-width: 700px) {
    display: block;
    margin-top: 20px;
  }

  button {
    display: flex;
    margin-right: 24px;
    font-size: 14px;
    border-radius: 6px;
    padding: 12px 24px;
    width: 126px;
    height: 48px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;

    @media screen and (max-width: 900px) {
      width: 100%;
      justify-content: center;
    }
  }

  span {
    font-size: 14px !important;
  }
}

.claim-card {
  margin-bottom: 16px;
  border: 1px solid #e2e8f0;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);

  .user-name {
    height: 159px;

    @media screen and (max-width: 700px) {
      height: 213px;
    }

    .bg-img {
      position: relative;
      max-width: 100px;
      min-height: 100px;
      max-height: 100px;
      border-radius: 50%;
      display: inline-block;
      margin-top: 24px;
      margin-left: 19.5px;

      @media screen and (max-width: 700px) {
        margin-left: 0px;
        margin-top: 0px;
      }

      .rating-badge {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 20%);
        font-size: 15px;
        border-radius: 20px;
        width: 55%;
      }
    }
  }

  .user-address {
    line-height: 15px;
  }

  .dovemed-card-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.125);

    span {
      font-size: 12px;
    }
  }
}

.background-image {
  background-position: center !important;
  background-size: contain !important;
  background-repeat: no-repeat !important;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/profile/circle/OtherCircleMembers.vue